import VerticalLinkCards from './verticalLinkCards';

export default VerticalLinkCards;
